const Sun: React.FC = () => {
  return (
    <svg id="light_mode_black_24dp" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 40 40">
      <rect id="Rectangle_16287" data-name="Rectangle 16287" width="40" height="40" fill="none" />
      <path
        id="Path_64623"
        data-name="Path 64623"
        d="M19.153,14.2A4.951,4.951,0,1,1,14.2,19.153,4.965,4.965,0,0,1,19.153,14.2m0-3.3A8.252,8.252,0,1,0,27.4,19.153,8.255,8.255,0,0,0,19.153,10.9ZM2.65,20.8h3.3a1.65,1.65,0,0,0,0-3.3H2.65a1.65,1.65,0,0,0,0,3.3Zm29.706,0h3.3a1.65,1.65,0,1,0,0-3.3h-3.3a1.65,1.65,0,0,0,0,3.3ZM17.5,2.65v3.3a1.65,1.65,0,0,0,3.3,0V2.65a1.65,1.65,0,0,0-3.3,0Zm0,29.706v3.3a1.65,1.65,0,1,0,3.3,0v-3.3a1.65,1.65,0,0,0-3.3,0ZM9.235,6.908A1.645,1.645,0,0,0,6.908,9.235l1.749,1.749a1.645,1.645,0,0,0,2.327-2.327ZM29.649,27.322a1.645,1.645,0,0,0-2.327,2.327L29.072,31.4A1.645,1.645,0,1,0,31.4,29.072ZM31.4,9.235a1.645,1.645,0,1,0-2.327-2.327L27.322,8.657a1.645,1.645,0,0,0,2.327,2.327ZM10.984,29.649a1.645,1.645,0,0,0-2.327-2.327L6.908,29.072A1.645,1.645,0,1,0,9.235,31.4Z"
        transform="translate(0.65 0.65)"
        fill="#ffb100"
      />
    </svg>
  );
};

export default Sun;
